import { Accordion } from '@/app/components/Accordion/Accordion';
import SectionContainer from '@/app/components/SectionContainer/SectionContainer';
import { faqData } from '@/app/modules/HomePageV2/staticData/faqData';
import { slugify } from '@/app/utils/slugify';

import styles from './FaqSection.module.scss';

export const FaqSection = () => (
  <SectionContainer className={styles.faqSectionContainer}>
    <h6 className={styles.faqSectionTitle}>
      Medical Recruitment <span>Agency FAQs</span>
    </h6>
    {faqData.map(({ title, content }, index) => (
      <Accordion
        key={slugify(title)}
        title={title}
        top={index === 0}
        bottom={index === faqData.length - 1}
      >
        <p className={styles.faqSectionContent}>{content}</p>
      </Accordion>
    ))}
  </SectionContainer>
);
